import type { ApiPromise } from '../../../utility';
import { apiCall } from '../../client';
import type {
  ConfigurationTopicCreateRequest,
  ConfigurationTopicRemoveRequest
} from '../../schema';

const path = 'configuration/topic';

export default {
  create: async (request: ConfigurationTopicCreateRequest): ApiPromise<void> => {
    return await apiCall('POST', path, request);
  },
  remove: async (request: ConfigurationTopicRemoveRequest): ApiPromise<void> => {
    return await apiCall('DELETE', path, request);
  }
};
